import { render, staticRenderFns } from "./pdf-viewer.component.vue?vue&type=template&id=3b7adf1f&"
import script from "./pdf-viewer.component.ts?vue&type=script&lang=ts&"
export * from "./pdf-viewer.component.ts?vue&type=script&lang=ts&"
import style0 from "./pdf-viewer.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports